import api from '@/helpers/api'
import { createNamespacedHelpers } from 'vuex'
export const { mapState, mapMutations, mapActions } = createNamespacedHelpers('contact')

export default {
  namespaced: true,
  state: {
    contacts: [],
  },
  mutations: {
    setContact: (state, data) => { state.contacts = data }
  },
  actions: {
    getContacts: async ({commit}) => {
      try {
        const response = await api.get('contact/list')
        // console.log("contacts :", response.data)
        commit('setContact', response.data)
      } catch (e) {
        console.error('[axios] getContacts :', e.message)
      }
    },
  }
}
